import { AxiosResponse } from "axios";
import api from "src/services/api/axiosService";
import { TempFileStoreAccessToken } from "./S3Uploader";




export const s3Endpoints = {
    GET_S3_TOKEN_URL: `/s3fileupload/GetToken`,
    GET_CDN_COOKIE_URL: `/amazon/cloudfront/cookies/url`

}

export async function S3TokenAccessor() {
  
     let response: AxiosResponse;
        try {
            response = await api.get<TempFileStoreAccessToken>(s3Endpoints.GET_S3_TOKEN_URL);
        }
        catch (error) {
            console.error("Error fetching token:", error);
            throw error;
        }

        if (!response) {
            throw new Error("No response received from the server.");
        }

        return response.data as TempFileStoreAccessToken;
  
}

